import { fetchPost } from "..";
import { STORAGE_KEYS, storage } from "../../utils/storage";

export const updateMemberPreferences = async (user) => {
  const formattedData = {
    preference: {
      member: { ...user.member },
    },
  };
  return await fetchPost("member/preferences", {}, formattedData, "PUT");
};

export const updateLocalStorageUser = async (updatedUser) => {
  await storage.save({
    key: STORAGE_KEYS.USER_DETAILS,
    data: updatedUser,
  });
};
